import { useEffect } from 'react';

import { TourKeys } from '@cast/constants';

import { setUserTriggeredDemoMode } from '@cast/infrastructure-demo';
import { useTourV2 } from 'core/tour-v2/TourProvider';

export const DemoController = () => {
  const { api } = useTourV2();

  useEffect(() => {
    setUserTriggeredDemoMode(true);

    api.start(TourKeys.OpinionatedPlatform);
  }, [api]);

  return null;
};
